<div class="receipt-reward-wrapper">
  <div class="receipt-reward-summary">
    <span *ngFor="let line of displayReward">{{ line }}</span>
  </div>
</div>
